import React from 'react'
import PropTypes from 'prop-types'

import { Card } from '../Card/Card'
import Dollars from '../Dollars/Dollars'
import InternalLink from '../InternalLink/InternalLink'
import { useRestaurant } from '../RestaurantProvider/RestaurantProvider'

import './MenuItemCard.css'

export const MenuItemCard = ({ item, endAdornment, dataTestid }) => {
  const { getRestaurantPath } = useRestaurant()

  if (!item) return null

  const { name, guid, itemGroupGuid, price } = item
  return (
    <li styleName='item'>
      <InternalLink
        data-testid={dataTestid}
        eventData={[
          ['ec', 'addProduct', { id: guid, name }],
          ['ec', 'setAction', 'click']
        ]}
        to={getRestaurantPath(`add/${guid}/${itemGroupGuid}`)}
      >
        <Card endAdornment={endAdornment}>
          <div styleName='wrapper'>
            <h2 styleName='name'>{name}</h2>
            {price > 0 && <p styleName='price'>
              <Dollars amount={price} />
            </p>}
          </div>
        </Card>
      </InternalLink>
    </li>
  )
}

const itemShape = PropTypes.shape({
  name: PropTypes.string.isRequired,
  guid: PropTypes.string.isRequired,
  itemGroupGuid: PropTypes.string.isRequired,
  imageUrl: PropTypes.string,
  price: PropTypes.number
})

MenuItemCard.propTypes = {
  item: itemShape,
  endAdornment: PropTypes.node,
  dataTestid: PropTypes.string.isRequired
}
